import { displayToast, sendAppsignalError, displayConfetti } from "../modules/utils";

class TicketScan {
  constructor(node) {
    this.element = node;
    this.ticketScanInput = this.element.querySelector(".js-ticket-scan-input");
    this.messageElement = this.element.querySelector(".js-ticket-message");

    this.elementInitialClasses = this.element.className;
    this.fetchUrl = this.element.dataset.url;
    this.validAudio = new Audio(this.element.dataset.validAudioUrl);
    this.invalidAudio = new Audio(this.element.dataset.invalidAudioUrl);
    this.warningAudio = new Audio(this.element.dataset.warningAudioUrl);

    this.initialize();
  }

  initialize() {
    this.ticketScanInput.focus();

    this.ticketScanInput.addEventListener("input", () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.activeAudio) {
          // This will stop the audio and reset it to the beginning (So that other audio can play)
          this.activeAudio.pause();
          this.activeAudio.currentTime = 0;
        }

        this.ticketScanInput.disabled = true;
        this.checkTicket();
      }, 350);
    });
  }

  checkTicket() {
    this.element.classList.add("animate");

    const formData = new FormData();
    formData.append(this.ticketScanInput.name, this.ticketScanInput.value);

    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      body: formData,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { state, message } = data;

        this.messageElement.textContent = message;

        switch (state) {
          case "valid":
            this.element.classList.add("valid-ticket");
            this.playAudio(this.validAudio);

            displayConfetti(this.element, {
              scalar: 1.5,
              particleCount: 75,
              startVelocity: 20,
              ticks: 60,
              spread: 360,
              gravity: 0,
              decay: 0.96,
            });

            break;
          case "warning":
            this.element.classList.add("warning-ticket");
            this.playAudio(this.warningAudio);
            break;
          default:
            this.element.classList.add("invalid-ticket");
            this.playAudio(this.invalidAudio);
            break;
        }
      })
      .catch((e) => {
        this.element.className = this.elementInitialClasses;
        this.element.classList.add("invalid-ticket");
        this.playAudio(this.invalidAudio);

        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "TicketScan", {
          response: this.response,
        });
      })
      .finally(() => {
        setTimeout(() => {
          this.element.className = this.elementInitialClasses;

          this.ticketScanInput.value = "";
          this.ticketScanInput.disabled = false;

          this.ticketScanInput.focus();
        }, 1500);
      });
  }

  playAudio(audioInstance) {
    this.activeAudio = audioInstance;
    this.activeAudio.play();
  }
}

const ticketScanElement = document.querySelector("[data-js='ticket-scan']");

if (ticketScanElement) {
  new TicketScan(ticketScanElement);
}
